/**
 * Master switch for Ruby Social Publishing in Super Admin. HIDDEN (owner, 2026-10-13) until a business that needs
 * it comes along — flip to true to bring back Integrations › Social publishing and the Online Presence publishing panel.
 * Keep in step with platform-app hooks/useSocialPublishing.ts SOCIAL_PUBLISHING_ENABLED.
 */
export const SOCIAL_PUBLISHING_ENABLED = false;
